import * as constants from "./constants";
export { constants };
/**
 * Get a URL parameter by name
 * https://stackoverflow.com/a/5158301/10557
 */

export var geURLParameterByName = function geURLParameterByName(search, name) {
  var match = RegExp("[?&]" + name + "=([^&]*)").exec(search);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
};